export default __webpack_public_path__ + "static/media/shorelinesThumb.9a23a240.jpg";